<template>
  <div v-if="item">
    <h2>{{ item.type_display }}</h2>

    <fields-list :item="item" :fields="fields" />
    <div class="save-panel">
      <svg class="svg-angle svg-angle-1" width="30" height="30" viewBox="0 0 29 29" xmlns="http://www.w3.org/2000/svg"><path d="M0 29V0C0 16.0163 12.9837 29 29 29H0Z"/></svg>
      <svg class="svg-angle svg-angle-2" width="30" height="30" viewBox="0 0 29 29" xmlns="http://www.w3.org/2000/svg"><path d="M0 29V0C0 16.0163 12.9837 29 29 29H0Z"/></svg>
      <button class="btn btn-warning btn-icon" @click="updateItem">
        <span class="ti-save"></span>{{ "save" | setText("Сохранить") }}
      </button>
    </div>
    <div class="mt-5">
      <h4>Подразделы</h4>
      <lessonplan-lessonplans :id="id" />
    </div>
  </div>
</template>
<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";
import LessonplanLessonplans from "./LessonplanLessonplans.vue";

export default {
  components: { LessonplanLessonplans },
  data: () => ({
    cardLink: "lessonplans",
    cardSetLink: "lessonplans",
    item: null,
    fields: [
      {
        col: "col-12 col-md-8",
        key: "name",
        label: "Название",
        type: "field",
        textType: "text",
      },
      {
        col: "col-12 col-md-4",
        key: "position",
        label: "Номер",
        type: "field",
        textType: "number",
      },
      {
        col: "col-12 col-md-6",
        label: "Автор",
        key: "author",
        type: "select",
        selectKey: "title",
        modal: "author",
        prefix: "author",
      },
      {
        col: "col-12 col-md-6",
        label: "Предмет",
        key: "discipline",
        type: "select",
        selectKey: "title",
        modal: "discipline",
        prefix: "lessonplan_discipline",
      },
      {
        col: "col-12 col-md-6",
        key: "locale",
        label: "Локализация контента",
        type: "locale",
        textType: "text",
      },
      {
        col: "col-12 col-md-6",
        label: "Для классов",
        key: "course_id",
        type: "course",
        selectKey: "title",
      },
      {
        selectKey: "position",
        label: "Для других классов",
        key: "courses",
        type: "selects",
        modal: "coursesModal",
      },

    ],
  }),
  props: ["id"],
  async created() {
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    pushLang: pushLang,
    async updateItem() {
      let item = await this.cardUpdate(
        this.cardSetLink,
        this.item,
        this.fields
      );
    },
  },
};
</script>
<style>
</style>
